export const QUOTE_PAYMENT_TERMS = [
  "Net 25",
  "Net 30",
  "Net 45",
  "Net 180",
  "Net 90",
  "Payment In Advance",
  "TBD",
] as const;

function localIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function defaultQuoteValidThrough(today = new Date()): string {
  const date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  date.setDate(date.getDate() + 60);
  if (date.getDay() === 6) date.setDate(date.getDate() + 2);
  if (date.getDay() === 0) date.setDate(date.getDate() + 1);
  return localIsoDate(date);
}

export function defaultQuoteComments(lines: ReadonlyArray<{ sku: string }>): string {
  const skus = lines.map((line) => line.sku.trim().toUpperCase());
  const hasTenWeekProduct = skus.some(
    (sku) => sku.includes("FI-3C") && sku.replace("FI-3C", "").includes("C"),
  );
  if (hasTenWeekProduct) return "Lead Time: 10 weeks.";

  const hasSixteenWeekProduct = skus.some(
    (sku) => sku.includes("FI-5A-W") || sku.includes("DM-1"),
  );
  return hasSixteenWeekProduct ? "Lead Time: 16 weeks." : "Lead Time: 8 weeks.";
}
